module.exports = __webpack_public_path__ + "img/image25.4dbffdc5.jpg";